import { render, staticRenderFns } from "./ActiveCode.vue?vue&type=template&id=1187b050&scoped=true&"
import script from "./ActiveCode.vue?vue&type=script&lang=js&"
export * from "./ActiveCode.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCode.vue?vue&type=style&index=0&id=1187b050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187b050",
  null
  
)

export default component.exports